// removed by extract-text-webpack-plugin
module.exports = {"container_edit":"styles__container_edit___4NBtq","space_edit":"styles__space_edit___1C1FT"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/ActionForm/CustomerEdit/styles.css
// module id = 3164
// module chunks = 0